export interface IOptionFilterable<T> {
  filteredOptions: T[];
  filteredText: string;
}

export function instanceOfIOptionFilterable<T>(instance: any): instance is IOptionFilterable<T> {
  return instance
    && (instance.filteredOptions !== undefined)
    && (instance.filteredText !== undefined);
}
